import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Thumb } from "./ProductTile";
import { rp } from "./util";

export default function VariantDialog({ group, imgs, onClose, onPick }) {
    return (
        <Dialog open={!!group} onOpenChange={(o) => !o && onClose()}>
            <DialogContent className="max-w-lg" data-testid="pos-variant-dialog">
                <DialogHeader><DialogTitle className="font-serif text-xl">{group?.title}</DialogTitle></DialogHeader>
                <div className="space-y-2 max-h-[60vh] overflow-y-auto">
                    {group?.items.map((it) => (
                        <button key={it.item_id} disabled={it.remaining_qty <= 0} onClick={() => onPick(it)} data-testid={`pos-variant-${it.item_id}`}
                            className="w-full flex items-center gap-3 rounded border border-mist p-2 text-left hover:border-sage-dark disabled:opacity-40">
                            <Thumb src={imgs[it.item_id]} className="h-12 w-12 rounded shrink-0" />
                            <div className="flex-1 min-w-0">
                                <p className="text-sm font-medium text-ink truncate">{it.variant || it.name}</p>
                                <p className="text-[11px] text-neutral-500 truncate">{it.sku}</p>
                            </div>
                            <div className="text-right shrink-0">
                                <p className="text-sm font-semibold text-sage-dark">{rp(it.price)}</p>
                                <p className="text-[11px] text-neutral-500">{it.remaining_qty <= 0 ? "Sold out" : `${it.remaining_qty} left`}</p>
                            </div>
                        </button>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
}
